<template>
<div class="container" style="min-width: 1700px!important;">
  <div id="div_banner">
    <img  src="../../assets/70.png" style="width: 100%;min-height: 300px;vertical-align: bottom"/>
    <div class="main-title">
      <h2>{{companyInfo.fcompanyName}}</h2>
      <div class="bom" v-html="companyInfo.fintroduction"></div>
<!--      <p>关于我们</p>-->
<!--      <span>About us</span>-->
    </div>
  </div>
<!--  <div class="ab1">-->
<!--    <div class="box">-->
<!--      <div id="company_summary" class="title">-->
<!--        <h2>公司简介</h2>-->
<!--        <h3>COMPANY</h3>-->
<!--      </div>-->
<!--      <div class="company_box1">-->
<!--        <img src="../../assets/69.png" />-->
<!--        <div>-->
<!--          <p class="title" style="padding-bottom: 0;">浙江科友信息工程股份有限公司</p>-->
<!--          <p class="underline"></p>-->
<!--          <p class="main">浙江科友信息工程股份有限公司（简称科友股份，股票代码：870398）-->
<!--            是一家集咨询服务、应用软件开发、应用系统集成及数据归集、数据交-->
<!--            换、数据分析、数据展现等为一体的解决方案提供商。主要为政府和企-->
<!--            业提供全面的“数字化改革”整体解决方案服务，并专注于物流园区、物-->
<!--            流企业产品研发，为物流产业互联，园区互通提供产品。</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div style="min-width: 1400px">-->
<!--        <div id="div_companyProfile" class="ab1_main" v-if="companyInfo">-->
<!--          <div class="pic_box">-->
<!--            &lt;!&ndash;          <img :src="baseUrl + companyInfo.fcompanyUrl " alt="">&ndash;&gt;-->
<!--            <img src="../../assets/gywm.png" alt="">-->
<!--          </div>-->
<!--          <div class="text">-->
<!--            <img src="../../assets/deng.png" style="position: absolute;top: 0;left: -154px">-->
<!--            <div class="top">-->
<!--              <h2>{{companyInfo.fcompanyName}}</h2>-->
<!--              &lt;!&ndash;          <img src="../../assets/21.png" alt="">&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="bom" v-html="companyInfo.fintroduction">-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="ab2">
    <div class="box">
      <div id="development_history" class="title">
        <h2 style="color: #fff">发展历程</h2>
        <h3 style="color: #fff">HISTORY</h3>
      </div>
      <div class="ab2_main clearfix">
<!--        <p style="font-size: 36px;text-align: center;color: #fff;font-weight: 800;margin-bottom: 106px;margin-top: 50px;">发展历程</p>-->
        <div class="right-line">
          <div style="position: relative;height: 100px">
            <span style="position:absolute;display: inline-block;border: 16px solid transparent;border-bottom: 16px solid #fff;top: -16px;right: -16px"></span>
          </div>
          <div v-for="(item,index) in companyHistory" :key='index'>
            <div class="history-main-right" :style="index === companyHistory.length -1 ? 'height: unset!important;' : ''" v-if="(companyHistory.length - index)%2">
              <span class="top-circular" :style="index === companyHistory.length -1 ? 'position: absolute;top: -7px;' : ''"></span>
              <span class="history-year">{{item.fhistoryYear}}</span>
              <span class="history-content">{{item.fcompanyHistory}}</span>
            </div>
            <div class="history-main" v-else>
              <span class="top-circular"></span>
              <span class="history-year">{{item.fhistoryYear}}</span>
              <span class="history-content">{{item.fcompanyHistory}}</span>
            </div>
          </div>
        </div>
<!--        <div class="left fl">-->
<!--          <div class="l_list" v-for="(item,index) in companyHistory" :key='index'>{{item.fhistoryYear}}</div>-->
<!--        </div>-->
<!--        <div id="div_developmentHistory" class="right fr">-->
<!--          <div class="r_list" v-for="item in companyHistory">-->
<!--            <h2>{{item.fhistoryYear}}</h2>-->
<!--            <div class="text">{{item.fcompanyHistory}}</div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
  <div class="ab3">
    <div class="box">
<!--      <p style="font-size: 36px;font-weight: 800;color: #333;text-align: center">-->
<!--        公司荣誉-->
<!--      </p>-->
      <div id="company_honor" class="title">
        <h2 class="cc">公司荣誉</h2>
        <h3 class="cc">HONOR</h3>
      </div>
      <div class="ab3_main">
        <div class="swiper-container" style="height: 400px;" >
           <div  class="swiper-wrapper" style="width: 4400px; height: 319px;">
             <div class="swiper-slide" style="box-sizing: border-box;padding: 10px;width: 300px; height: 380px;box-shadow: 0px 6px 10px 0px rgba(43, 149, 242, 0.2);" v-for="item in companyHonor">
               <div class="pic_box">
                 <img :src="baseUrl+ item.fhonorUrl" alt="公司荣誉" style="width: 280px;height: 200px">
               </div>
               <h2 style="font-size: 16px">{{item.fhonor}}</h2>
               <p>{{item.fhonorExplain}}</p>
             </div>
           </div>
        </div>
        <a href="javascript:;" class="prev"></a>
        <a href="javascript:;" class="next"></a>
      </div>
    </div>
  </div>
  <div style="background-color:#fff;">
    <div class="ab4">
      <div id="corporate_culture" class="title">
        <h2>企业文化</h2>
        <h3>CULTURE</h3>
      </div>
      <div class="box">
        <!--      <p style="font-size: 36px;color: #333;font-weight: 800;text-align: center">企业文化</p>-->
        <div style="position: relative;margin-top: 50px;">
          <p class="left-content" v-for="item in CompanyCulture">
            <span style="font-size: 18px;font-weight: 800;color: #333;line-height: 30px;">{{item.fcultureName}}</span>
            <span style="font-size: 18px;font-weight: 400;color: #333;line-height: 30px;">{{item.fculture}}</span>
          </p>
          <img src="../../assets/qiyewenhua.png" />
        </div>
        <!--      <div id="corporate_culture" class="title">-->
        <!--        <h2>企业文化</h2>-->
        <!--        <h3>CULTURE</h3>-->
        <!--      </div>-->
        <!--      <div id="div_corporateCulture" class="ab4_main clearfix">-->
        <!--        <div class="ab4_list" v-for="item in CompanyCulture">-->
        <!--          <div class="wrap">-->
        <!--            <div class="pp p1">-->
        <!--              <img :src="baseUrl + item.fcultureUrl">-->
        <!--              <h2>{{item.fcultureName}}</h2>-->
        <!--              <div class="text">-->
        <!--                <p>{{item.fculture}}</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
    </div>
  </div>
  <div class="i4">
    <div class="box">
      <div id="cooperative_customer" class="title">
        <h2>合作客户</h2>
        <h3>COOPERATION</h3>
      </div>
      <div id="div_customer" class="i4_main">
        <div class="top about_top clearfix">
          <a href="javascript:;" v-for="item in CompanyCooperation">
            <img :src="baseUrl + item.fcooperation" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import Swiper from "swiper"
  import 'swiper/dist/css/swiper.css';
  import axios from '../../../static/js/commonAxios'
    export default {
      name: "about-us",
      data(){
        return{
          companyInfo:'',
          companyHistory:[],
          companyHonor:[],
          CompanyCulture:[],
          CompanyCooperation:[],
          baseUrl:'',
          imgUrl:'',//头部图
        }
      },
      mounted(){
        this.baseUrl = process.env.API_ROOT;
        this.getbar()
        this.getCompanyDate()
        this.getCompanyHistory()
        this.getCompanyHonor()
        this.getCompanyCulture()
        this.getCompanyCooperation()
      },
      methods:{
        getbar(){
          axios.get('/api/bar').then((res) => {
            console.log(res);
            if(res.data.success){
              let item=res.data.items
              item.forEach(arr=>{
                if(arr.fbar==='关于我们'){
                  this.imgUrl =   arr.fbarUrl
                }
                console.log(this.imgUrl);
              })

              console.log(this.imgUrl);
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        getCompanyDate(){
          axios.get('/api/company').then((res) => {
            if(res.data.success){
              this.companyInfo = res.data.items[0]
              console.log(this.companyInfo);
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        getCompanyHistory(){
          axios.get('/api/history').then((res) => {
            if(res.data.success){
              this.companyHistory = res.data.items
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        getCompanyHonor(){
          axios.get('/api/honor').then((res) => {
            if(res.data.success){
              this.companyHonor = res.data.items
              this.$nextTick(()=>{
                new Swiper('.swiper-container', {
                  loop : true,
                  navigation: {
                    nextEl: '.prev',
                    prevEl: '.next',
                  },
                  pagination: {
                    el: '.swiper-pagination',
                  },
                  slidesPerView: 'auto',
                  centeredSlides: true,
                  paginationClickable: true,
                  spaceBetween: 30,
                  autoplay:true
                });
              })
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        getCompanyCulture(){
          axios.get('/api/culture').then((res) => {
            if(res.data.success){
              this.CompanyCulture = res.data.items
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        getCompanyCooperation(){
          axios.get('/api/cooperation').then((res) => {
            if(res.data.success){
              this.CompanyCooperation = res.data.items
              console.log(this.CompanyCooperation)
            }else{
              this.$message.error(res.data.msg)
            }
          })
        }
      }
    }
</script>

<style scoped>
  .title{
    text-align: center;
    background: url(../../assets/2.png) no-repeat center 15px;
    padding-bottom: 50px;
  }
  .title h2{
    font-size: 30px;
    color: #000;
  }
  .title h3{
    font-size: 14px;
    color: #333;
    margin-top: 10px;
  }
  /* about*/
  .ab1{
    width: 100%;
    padding-top: 80px;
  }
  .ab1 .box{
    width: 100%;
  }
  .ab1 .ab1_main{
    width: 100%;
    position: relative;
    margin-top: 60px;
  }
  .ab1 .ab1_main .pic_box{
    width: 100%;
  }
  .ab1 .box .company_box1{
    width: 1150px;
    height: 400px;
    margin: 70px auto;
    position: relative;
  }
  .ab1 .box .company_box1 div {
    position: absolute;
    box-sizing: border-box;
    background-color: #fff;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 600px;
    height: 326px;
    padding: 47px;
  }
  .ab1 .box .company_box1 div .title {
    height: 22px;
    font-size: 22px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
    text-align: left;
    background: none;
  }
  .ab1 .box .company_box1 div .underline {
    width: 68px;
    height: 5px;
    background: #8FC31F;
    margin: 16px 0;
  }
  .ab1 .box .company_box1 div .main {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
  }
  .ab1 .ab1_main .pic_box img{
    width: 100%;
    position: relative;
    vertical-align: middle;
  }
  /*.ab1 .ab1_main .pic_box .img1{*/
  /*  position: absolute;*/
  /*  width: 74px;*/
  /*  height: 74px;*/
  /*  left: -35px;*/
  /*  bottom: -45px;*/
  /*}*/
  .ab1 .ab1_main .text{
    box-sizing: border-box;
    width: 72%;
    height: 570px;
    /*min-width: 900px;*/
    background-color: #fff;
    margin: 0 auto;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 50px;
    padding: 50px 360px 0 144px
  }

  .ab1 .ab1_main .text .top{
    width: 100%;
  }
  .ab1 .ab1_main .text .top h2{
    height: 38px;
    font-size: 36px;
    font-weight: 800;
    color: #333333;
    line-height: 30px;
  }
  .ab1 .ab1_main .text .top img{
    display: block;
    position: absolute;
    top: 65px;
    right: 20px;
  }
  .ab1 .ab1_main .text .bom{
    width: 100%;
    margin-top: 35px;
    color: #333;
    line-height: 25px;
    font-size: 14px;
  }

  .ab2{
    width: 100%;
    padding-top: 80px;
    padding-bottom: 110px;
    background: url(../../assets/fazhan.png) no-repeat center center;
    background-size:100% 100%;
    /*background: #1E56C3;*/
  }
  .ab2 .box {
    width: 100%;
  }
  .ab2 .ab2_main{
    width: 1200px;
    margin: 0 auto;
    /*margin-top: 60px;*/
  }
  .ab2 .ab2_main .right-line{
    position: relative;
    box-sizing: border-box;
    width: 50%;
    border-right: 1px solid #fff;
  }
  .ab2 .ab2_main .right-line .history-main {
    box-sizing: border-box;
    padding-right: 50px;
    position: relative;
    height: 100px;
  }
  .ab2 .ab2_main .right-line .history-main span{
    display: inline-block;
  }
  .ab2 .ab2_main .right-line .history-main .top-circular{
    position: absolute;
    right: -9px;
    top: -9px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 0 14px #fff;
  }
  .ab2 .ab2_main .right-line .history-main .history-year{
    position: absolute;
    right: -150px;
    top: -18px;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
  }
  .ab2 .ab2_main .right-line .history-main .history-content{
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    padding-right: 50px;
    text-align: right;
    top: -11px;
    font-size: 16px;
    color: #fff;
  }
  .ab2 .ab2_main .right-line .history-main-right {
    box-sizing: border-box;
    position: relative;
    right: -650px;
    height: 100px;
  }
  .ab2 .ab2_main .right-line .history-main-right span{
    display: inline-block;
  }
  .ab2 .ab2_main .right-line .history-main-right .top-circular{
    position: absolute;
    /*right: -9px;*/
    left: -59px;
    top: -9px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 0 14px #fff;
  }
  .ab2 .ab2_main .right-line .history-main-right .history-year{
    position: absolute;
    left: -200px;
    top: -18px;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
  }
  .ab2 .ab2_main .right-line .history-main-right .history-content{
    position: absolute;
    top: -11px;
    font-size: 16px;
    color: #fff;
  }
  /*.ab2 .ab2_main .left{*/
  /*  width: 80px;*/
  /*  background: url(../../assets/32.jpg) repeat-y right 15px;*/
  /*  position: relative;*/
  /*  top: 20px;*/
  /*}*/
  /*.ab2 .ab2_main .left .l_list{*/
  /*  width: 85.5px;*/
  /*  height: 200px;*/
  /*  background: url(../../assets/22.png) no-repeat right 12px;*/
  /*  font-size: 24px;*/
  /*  color: #666;*/
  /*  position: relative;*/
  /*  top: -20px;*/
  /*}*/
  /*.ab2 .ab2_main .right{*/
  /*  width: 975px;*/
  /*}*/
  /*.ab2 .ab2_main .right .r_list{*/
  /*  width: 975px;*/
  /*  height: 100px;*/
  /*  background: url(../../assets/23.png) no-repeat center center;*/
  /*  padding: 40px 47.5px;*/
  /*  margin-top: 20px;*/
  /*  position: relative;*/
  /*  top: -30px;*/
  /*  background-size: 100% 100%;*/
  /*}*/
  .ab2 .ab2_main .right .r_list h2{
    font-size: 18px;
    color: #333;
    font-weight: bold;
    padding-bottom: 15px;
    background: url(../../assets/34.jpg) no-repeat left bottom;
    margin-bottom: 10px;
  }
  .ab2 .ab2_main .right .r_list .text{
    padding-left: 15px;
    line-height: 30px;
    font-size: 14px;
    color: #666;
    background: url(../../assets/35.jpg) no-repeat left 12px;
  }
  .ab2 .ab2_main .right .r_list .pic_box{
    width: 100%;
    margin-top: 10px;
    display: none;
  }
  .ab3{
    width: 1920px;
    height: 520px;
    position: relative;
    left: 50%;
    margin-left: -960px;
    padding-top: 144px;
    padding-bottom: 170px;
    /*background: url(../../assets/36.jpg) no-repeat center center;*/
  }
  .ab3 .box {
    width: 1000px;
  }
  .ab3 .ab3_main{
    width: 100%;
    margin-top: 84px;
    position: relative;
  }
  .ab3 .ab3_main .swiper-slide{
    /*width: 400px !important;*/
    text-align: center;
  }
  .ab3 .ab3_main .swiper-slide .pic_box{
    width: 280px;
    /*height: 280px;*/
    margin: 0 auto;
    margin-bottom: 20px;
    overflow: hidden;
  }
  .ab3 .ab3_main .swiper-slide h2{
    color: #333;
    font-size: 18px;
    line-height: 30px;
  }
  .ab3 .ab3_main .swiper-slide p{
    font-size: 15px;
    text-align: left;
    padding: 0 16px;
    margin-top: 18px;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
  }

  /*.title .cc{*/
  /*  color: #fff;*/
  /*}*/
  .ab3 .ab3_main .prev,.ab3 .ab3_main .next{
    width: 38px;
    height: 38px;
    position: absolute;
    top: 50%;
    outline: none;
    margin-top: -14px;
  }
  .ab3 .ab3_main .prev{
    left: -40px;
    outline: none;
    background: url(../../assets/25.png) no-repeat center center;
  }

  .ab3 .ab3_main .next{
    right: -40px;
    background: url(../../assets/26.png) no-repeat center center;
  }

  .ab4{
    box-sizing: border-box;
    width: 100%;
    padding-top: 144px;
    padding-bottom: 80px;
    /*background-color: #fff;*/
    background: url(../../assets/wenhua.png) no-repeat center center;
  }
  .ab4 .box {
    position: relative;
    height: 500px;
  }
  .ab4 .box div {
    /*position: relative;*/
    height: 100%;
  }
  .ab4 .box div .left-content{
    position: relative;
    box-sizing: border-box;
    padding: 14px 0 14px 150px;
    width: 50%;
    top: 25%;
    transform:translateY(-50%);
  }
  .ab4 .box div .left-content span {
    display: block;
  }
  .ab4 .box div img{
    position: absolute;
    right: -100px;
    top: 50px;
    width: 594px;
  }
  /*.ab4 .ab4_main{*/
  /*  width: 100%;*/
  /*  margin-top: 60px;*/
  /*  display: flex;*/
  /*  justify-content: center*/
  /*}*/
  /*.ab4 .ab4_main .ab4_list{*/
  /*  width: 400px;*/
  /*  height: 300px;*/
  /*  float: left;*/
  /*}*/
  /*.ab4 .ab4_main .ab4_list .wrap{*/
  /*  width: 300px;*/
  /*  height: 300px;*/
  /*  border-radius: 160px;*/
  /*  border:10px solid #e5e5e5;*/
  /*  margin: 0 auto;*/

  /*  transition: all .8s;*/
  /*  -moz-transition: all .8s; !* Firefox 4 *!*/
  /*  -webkit-transition: all .8s; !* Safari 和 Chrome *!*/
  /*  -o-transition: all .8s; !* Opera *!*/
  /*  overflow: hidden;*/
  /*}*/
  /*.ab4 .ab4_main .ab4_list .wrap .pp{*/
  /*  width: 300px;*/
  /*  height: 200px;*/
  /*  text-align: center;*/
  /*  padding-top: 100px;*/
  /*  transition: all 2s;*/
  /*  -moz-transition: all 2s; !* Firefox 4 *!*/
  /*  -webkit-transition: all 2s; !* Safari 和 Chrome *!*/
  /*  -o-transition: all 2s; !* Opera *!*/
  /*  position: relative;*/
  /*}*/
  .ab4 .ab4_main .ab4_list .wrap .pp img{
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1
  }
  .ab4 .ab4_main .ab4_list .wrap .pp h2{
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 15px;
    background: url(../../assets/37.jpg) no-repeat center bottom;
  }
  .ab4 .ab4_main .ab4_list .wrap .pp .text{
    margin-top: 10px;
    line-height: 25px;
    color: #f5f5f5;
  }
  .ab4 .ab4_main .ab4_list .wrap:hover{
    border-color: #8ec31f;
  }

  .i4{
    width: 100%;
    /*padding-top: 100px;*/
    padding-bottom: 80px;
    background: #fff;
  }
  .i4 .i4_main{
    width: 100%;
    margin-top: 60px;
  }
  .i4 .i4_main .top{
    width: 100%;
    padding-bottom: 75px;
    border-bottom: 1px solid #ccc;
  }
  .i4 .i4_main .top a{
    display: block;
    width: 270px;
    height: 90px;
    overflow: hidden;
    margin: 0 20.6px;
    /*margin-right: 26.6px;*/
    float: left;
  }
  .i4 .i4_main .top a img{
    display: block;
    width: 270px;
    height: 90px;
  }
  .i4 .i4_main .bom{
    width: 100%;
  }
  .i4 .i4_main .bom a{
    width: 300px;
    height: 280px;
    float: left;
    display: block;
  }
  .i4 .i4_main .bom a img{
    display: block;
    width: 100%;
  }
</style>
<style>
  .container #div_banner .main-title{
    position: absolute;
    min-width: 800px;
    top: 13rem;
    left: 50%;
    transform: translate(-50%);
  }
  .container #div_banner .main-title h2 {
    text-align: center;
    font-size: 30px;
    font-weight: 500;
    color: #FFFFFF;
  }
  /*.container #div_banner .main-title .bom {*/
  /*  font-size: 16px!important;*/
  /*}*/
  .container #div_banner div .bom .p {
    background-color: transparent!important;
    font-size: 9px;
    font-weight: 400;
    color: #FFFFFF;
    letter-spacing: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutUs/aboutUs.vue